import React from 'react';
import PropTypes from 'prop-types';

export const DocumentLevel = React.createContext(1);

export const NestDocumentLevel = ({ children }) => (
  <DocumentLevel.Consumer>
    {level => <DocumentLevel.Provider value={level + 1}>{children}</DocumentLevel.Provider>}
  </DocumentLevel.Consumer>
);

export const RootDocumentLevel = ({ children }) => (
  <DocumentLevel.Provider value={1}>{children}</DocumentLevel.Provider>
);

NestDocumentLevel.propTypes = {
  children: PropTypes.node.isRequired,
};

RootDocumentLevel.propTypes = {
  children: PropTypes.node.isRequired,
};
